<template>
  <v-container>
  <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
   <v-card
    class="mx-auto"
  
  >
    <v-card
      dark
      flat
    >
    
      <v-card-title class="pa-2 white">
       
        <h3 class="headline font-weight-light black--text text-center grow">Work Experience</h3>
        
      </v-card-title>
      <v-img
        src="../assets/forest.jpg"
        gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
        height="300"
      >
      
      </v-img>
    </v-card>
    <v-card-text class="py-0">
    <v-timeline>
    <v-timeline-item
      v-for="(year, i) in years"
      :key="i"
      :color="year.color"
      small
    >
      <template v-slot:opposite>
        <span
          :class="`headline font-weight-bold ${year.color}--text`"
          v-text="year.year"
        ></span>
      </template>
      <div class="py-4">
        <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">{{year.company}}</h2>
        <div>
         {{year.Description}}
        </div>
      </div>
    </v-timeline-item>
  </v-timeline>
    </v-card-text>
  </v-card>
      </v-flex>
  </v-layout>
</v-container>
</template>

<script>
 export default {
    data: () => ({
      years: [
        {
          color: 'cyan',
          year: '2012 - Now',
          company: 'CNP Asfalistiki',
          Description:'Software Developer / Analyst'
        },
        {
          color: 'green',
          year: '2005 - 2012',
          company: 'Logicom Solutions',
          Description:'Software Developer / Analyst'
        },
        {
          color: 'pink',
          year: '2004 - 2005',
          company: 'Alico Life',
          Description:'Developer / Analyst'
        },
        {
          color: 'amber',
          year: '2002 - 2004',
          company: 'Hellenic Techincal',
          Description:'Techincal Enginner - Software Developer'
        },
        {
          color: 'orange',
          year: '2000 - 2002',
          company: 'Stroumsas EPE',
          Description:'Production Manager - Software Developer'
        },
      ],
    }),
  }
</script>
